import React from 'react';

const NoRecord = () => {
   return (
      <div className='no-record-root' title='no-record'>
         No Record Found
      </div>
   );
};
export default NoRecord;
